import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext, useEffect, useState} from "react";
import {getStates} from "../common/api/WebApi";
import {displayPhone, handleDefaultValues} from "../common/Utils";
import {useForm, useWatch} from 'react-hook-form';
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import MDButton from "../../components/MDButton";
import {getReferralTypes} from "../common/api/InventoryApi";
import {CompanyContext} from "../../lib/CompanyContext";

export default function ManageClientModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [company, setCompany] = useState();
  useEffect(()=>{
    if (companyContext) {
      setCompany(companyContext?.company)
    }
  },[companyContext]);

  const [customer, setCustomer] = useState(props.customer);

  const [newCustomer, setNewCustomer] = useState(!!!props.customer?.guid);
  const [states, setStates] = useState([]);
  const [referralTypes, setReferralTypes] = useState([]);
  const [formInvalid, setFormInvalid] = useState(false);
  const [statesReady, setStatesReady] = useState(false);

  const [hasPass, setHasPass] = useState(false);

  useEffect(() => {
    getReferralTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _types = result;
        let _choose = {id: -10, name: 'Choose Referral Type...'};
        _types.unshift(_choose);
        setReferralTypes(_types);
      }
    })
    getStates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _states = result.filter(x => x.stateId > 0);
        let _choose = {stateId: -1, stateName: 'Choose State...'};
        _states.unshift(_choose);
        setStates(_states);
      }
    });
  }, [props.show]);

  useEffect(() => {
    if (states?.length > 0) {
      if (!customer || !customer.state || !customer.state.stateId) {
        setValue('state.stateId', states[0].stateId);
      }
    }
  }, [states]);

  const {
    register, handleSubmit,
    setValue,
    control,
    reset,
    formState: {errors}
  } = useForm({
    values: handleDefaultValues(customer),
  });

  useEffect(() => {
    setCustomer({...props.customer});
  }, [props.customer]);

  useEffect(() => {
    reset();
  }, [newCustomer]);
  const handleClose = () => {
    props.handleClose();
  };

  const password = useWatch({
    control,
    name: "passwd",
  });

  const [passmessage, setPassMessage] = useState('');

  useEffect(()=> {
    setHasPass(password?.length > 0)
    if (password?.length === 0) {
      setPassMessage('');
    }
  },[password])

  const handleSaveCustomer = (data) => {
    if (hasPass && data.passwd !== data.passwd2) {
      setPassMessage("Passwords do not match");
      return;
    }
    props.handleSaveCustomer(data);
  };

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form
        autoComplete={'off'}
        onSubmit={handleSubmit(handleSaveCustomer)} id={'customerForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{newCustomer ? 'Create New' : 'Manage'} Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col py-2 py-md-0'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="text" required
                               {...register('firstName')}
                               autoComplete="off"
                               variant="outlined"
                               InputLabelProps={{shrink: true}}
                               placeholder={"Enter First Name"}
                               className="form-control" id="firstName"
                               label="First name"/>
                    </div>
                  </Col>

                  <Col className={'col py-2 py-md-0'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput type="text" required
                               {...register('lastName')}
                               variant="outlined"
                               InputLabelProps={{shrink: true}}
                               className="form-control" id="lastName"
                               placeholder={"Enter Last Name"}
                               label="Last Name"/>
                    </div>
                  </Col>
                </Row>
                <Row className={'my-4'}>
                  <Col className={'col'} md={6} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        type="email" required
                        {...register('email')}
                        autoComplete="off"
                        variant="outlined"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="email"
                        placeholder={"Enter Email"}
                        label="Email"/>

                      <label htmlFor="emailEnabled" className={'my-4'}>
                        <input type="checkbox"
                               defaultChecked={newCustomer ? true : customer?.emailEnabled}
                               {...register('emailEnabled')}
                               autoComplete="off"
                               id="emailEnabled"/>
                        &nbsp;Email Allowed
                      </label>
                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('primaryPhone', {
                          onChange: (e) => {
                            e.target.value = displayPhone(e.target.value);
                          }
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Phone"}
                        autoComplete="off"
                        className="form-control" id="primaryPhone"
                        label="Phone"/>

                      <label htmlFor="smsEnabled" className={'my-4'}>
                        <input type="checkbox"
                               defaultChecked={newCustomer ? true : customer?.smsEnabled}
                               {...register('smsEnabled')}
                               id="smsEnabled"/>
                        &nbsp;SMS Allowed
                      </label>
                    </div>
                  </Col>
                  <Col className={'col py-2 py-sm-0 mb-4'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="password"
                        {...register('passwd')}
                        placeholder={"Enter Password"}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="passwd"
                        label="Password"/>
                    </div>
                  </Col>

                  <Col className={'col py-2 py-sm-0 mb-4'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        required={hasPass}
                        variant="outlined" type="password"
                        {...register('passwd2', {
                          required: hasPass,
                        })}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Re-Enter Password"}
                        className="form-control" id="passwd2"
                        label="Re-Enter Password"/>
                    </div>
                  </Col>

                  <Col className={'col py-2 py-sm-0'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('address1', {
                        })}
                        placeholder={"Enter Address"}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="address1"
                        label="Address"/>
                    </div>
                  </Col>

                  <Col className={'col py-2 py-sm-0'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('address2')}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Address 2"}
                        className="form-control" id="address2"
                        label="Address 2"/>
                    </div>
                  </Col>

                </Row>

                <Row className={'my-4'}>
                  <Col className={'col col py-2 py-sm-0'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('city', {
                        })}
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter City"}
                        autoComplete="off"
                        className="form-control" id="city"
                        label="City"/>
                    </div>
                  </Col>

                  <Col className={'col col py-2 py-sm-0'} sm={4} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor={"state"} className={"native-label mt-n3"}>State</label>
                      {states?.length > 0 &&
                        <NativeSelect
                                      autoComplete="off"
                                      variant="outlined"
                                      id={'state'} name={'state'} className={'form-control'}
                                      {...register('state.stateId',{
                                      })}>
                          {
                            states.map((c) =>
                              <option value={c.stateId} key={c.stateId}>
                                {c.stateName}
                              </option>)
                          }
                        </NativeSelect>}
                      {errors['state.stateId'] && errors['state.stateId'].type === "required" && (
                        <span className={'text-danger'}>Please choose a State</span>
                      )}
                      {errors.state?.stateId && errors.state?.stateId.type === "min" && (
                        <span className={'text-danger'}>Please choose a State</span>
                      )}
                    </div>
                  </Col>

                  <Col className={'col col py-2 py-sm-0'} sm={4} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('zipCode',
                          {
                          })}
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Zip"}
                        className="form-control" id="zipCode"
                        label="Zip Code"/>
                      {errors.zipCode && errors.zipCode.type === "minLength" && (
                        <span className={'text-danger'}>Please enter valid Postal Code</span>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor={"referralType"} className={"native-label"}>Referral Type</label>
                      {referralTypes?.length > 0 &&
                        <NativeSelect
                          autoComplete="off"
                          variant="outlined"
                          id={'referralType'} name={'referralType'} className={'form-control'}
                          {...register('referralType.id')}>
                          {
                            referralTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

          {passmessage && <Row><Col xs={12}><center>{passmessage}</center></Col></Row>}

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}